import React from "react";
import { Users, Gavel, Clock, Shield } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroStats = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const statsData = labels.menuPages?.buyCar?.hero?.stats || [];

  const icons = [
    <Gavel className="w-6 h-6 md:w-8 md:h-8 text-blue-400" />,
    <Users className="w-6 h-6 md:w-8 md:h-8 text-purple-400" />,
    <Clock className="w-6 h-6 md:w-8 md:h-8 text-green-400" />,
    <Shield className="w-6 h-6 md:w-8 md:h-8 text-yellow-400" />,
  ];

  const stats = statsData.map((stat: any, index: number) => ({
    icon: icons[index] || icons[0],
    number: stat.number || "",
    label: stat.label || "",
  }));

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto mt-12 md:mt-16 px-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white/10 text-white backdrop-blur-lg rounded-xl md:rounded-2xl p-4 md:p-6 border border-white/20 hover:bg-white/15 transition-all duration-300"
        >
          <div className="flex justify-center mb-2 md:mb-3">{stat.icon}</div>
          <div className="text-2xl md:text-3xl font-bold mb-1">
            {stat.number}
          </div>
          <div className="text-xs md:text-sm text-gray-300">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default HeroStats;
